<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >

      
     <w-form
            class=""
            v-model="form.valid"
            v-model:errors-count="form.errorsCount"
            @validate="submitResit"
            @success="onSuccess"
        >

    <z-page title="Butiran Bayaran (Bil)">
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>Bil</td>
                                <td>Jenis</td>
                                <td>Nama Pemilik</td>
                                <td>No. Rujukan</td>
                                <td>amaun (RM)</td>
                                <td>Amaun Bayar (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in form_data.butiran_bayaran">
                                <td >{{ index + 1 }}</td>
                                <td>INTEGRASI</td>
                                <td>{{ form_data.nama }}</td>
                                <td>{{ form_data.no_rujukan }}</td>
                                
                                <td align="right">
                                        {{$zutil.currency(dt.amaun)}}
                                </td>
                               
                                <td align="right">
                                        {{$zutil.currency(dt.amaun)}}
                                </td>
                                
                            </tr>
                            <tr>
                                <td colspan="5" align="right">Jumlah (RM)</td>
                                <td align="right"><b>
                                        {{$zutil.currency(amaun_butiran)}}
                                </b></td>
                            </tr>
                            <tr>
                                <td colspan="5" align="right">
                                    Penggenapan (RM)
                                </td>
                                <td align="right"><b>0</b></td>
                            </tr>
                            <tr>
                                <td colspan="5" align="right">
                                    Jumlah Dibayar (RM)
                                </td>
                                <td align="right">
                                    <b>
                                        {{$zutil.currency(amaun_butiran)}}
                                    </b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex>

            <w-flex justify-center align-center class="mt5">
                    
                    <br>
                    <div class="w-card__content content-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Cara Bayaran</td>
                                    <td>Bank</td>
                                    <td>No Cek / Bank Draf / Transaksi Bank</td>
                                    <td>Amaun (RM)</td>
                                    <!-- <td>
                                        <w-icon class="mr1" @click="addBayar"
                                            >fal fa-plus</w-icon
                                        >
                                    </td> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(d, index) in form.cara_bayaran">
                                    <!-- <tr> -->
                                    <td>
                                        <z-lookup
                                            :url="
                                                service_utiliti +
                                                'lookup/cara_bayar_kaunter'
                                            "
                                            :sort="false"
                                            :cache="false"
                                            v-model="d.lkp_cara_bayaran_id"

                                            required
                                            :validators="[validators.required]"
                                        />
                                        
                                        
                                        
                                    </td>
                                    <td>

                                        <template v-for="(c, index) in cara_bayar">
                                        <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_bank  == 1" >
                                            <z-lookup
                                                :url="
                                                    service_utiliti +
                                                    'lookup/bank'
                                                "
                                                :sort="false"
                                                :cache="false"
                                                v-model="d.lkp_bank_id"
                                                :validators="[
                                                    validators.required,
                                                ]"
                                            />
                                        </template>
                                        </template>
                                    </td>
                                    <td>
                                        <template v-for="(c, index) in cara_bayar">
                                        <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_dokumen  == 1" >
                                            <w-input
                                                class="mb4"
                                                v-model="d.no_dokumen"
                                                :validators="[
                                                    validators.required,
                                                ]"
                                                
                                            />
                                        </template>
                                        </template>
                                    </td>
                                    <td align="right" >
                                        <!-- <z-money
                                            v-model:originalValue="d.amaun"
                                            required
                                            v-on:keyup="cekAmaunBayar(d)"
                                            validators="[validators.required]"
                                        /> -->
                                        {{ $zutil.currency(d.amaun) }}
                                        <template v-for="(c, index) in cara_bayar">
                                        <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_terminal  == 1" >
                                        <w-button v-if="terminal && terminal.ip_address && d.lkp_cara_bayaran_id && d.lkp_cara_bayaran_id != 4 && hantarTerminal == 1"
                                            class="my1 "
                                            @click="sendTerminal(d)">
                                            Hantar Terminal
                                        </w-button><br>
                                        </template>
                                        </template>
                                        <span class="w-form-el__error error w-form-el__error w-form-el__error">{{error_termilan}}</span>
                                        
                                    </td>
                                    <!-- <td>
                                        <w-icon
                                            class="mr1"
                                            @click="removeBayar(index)"
                                            >fal fa-trash</w-icon
                                        >
                                    </td> -->
                                </tr>
                                <tr>
                                    <td colspan="3" align="right">
                                        Jumlah (RM)
                                    </td>
                                    <td align="right">
                                        <b>
                                            {{
                                                $zutil.currency(amaun_butiran
                                                )
                                            }}
                                        </b>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" align="right">
                                        Jumlah Perlu Dibayar(RM)
                                    </td>
                                    <td align="right">
                                        <b>{{
                                                $zutil.currency(amaun_butiran
                                                )
                                            }} </b>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" align="right">
                                        Baki(RM)
                                    </td>
                                    <td align="right">
                                        <b>0.00</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </w-flex>
        </z-page>
        <w-flex class="mt3" wrap align-center justify-end>
                <div class="spacer" />
                    <w-button
                        class="my1"
                        type="submit"
                        :disabled="form.valid === false"
                        :loading="form.submitted && !form.sent"
                    >
                        <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon>
                        Hantar
                    </w-button>
            </w-flex>


        </w-form>

      
  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

  
    resourceurl: this.service_kutipan +'integrasi',
    reload: true,
    loading : true,
    files:[],
    

    hantarTerminal : 1,
    terimaan : {},
    terminal : {},
    form_data : {},
    cara_bayaran : [],
    bank : [],
            integrasi: [],


        
    
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Teriaman Cek', route: '/kutipan' },
        { label: 'Papar', route: '/kutipan/'+this.id },
      ],

      
    }
  },
    methods: {

     sendTerminal(d) {
            if(this.terminal && this.terminal.ip_address){
                console.log(this.connection);
                if ( !this.connection ) {
                    this.connection = new WebSocket("wss://"+this.terminal.ip_address+":"+this.terminal.port+"/")
                    if ( !this.connection ) {
                        this.error_termilan = "Terminal POS tidak berjaya disambung";
                    }
                }
                if ( this.connection.readyState != 1 ) {
                    this.connection.close();
                    this.connection = new WebSocket("wss://"+this.terminal.ip_address+":"+this.terminal.port+"/")
                }
                if(this.connection.readyState == 1){
                    this.hantarTerminal = 0
                    var message = '{"type":"TXNREQ", "parameters":{"transactionType":"0200", "subTranType":"00", "paymentMethod":"card", "amount":"'+d.amaun+'", "amountOther":"0.00", "reference":"'+this.terimaan.id+'"} }';
                    this.connection.send(message);
                    this.connection.onmessage = function(event) {
                      console.log(event);
                      console.log(event.data);

                    console.log(event.data);
                    console.log(event.data.parameters)
                      if(event.data.parameters){
                          d.no_dokumen = event.data.parameters.traceNo
                      }
                      if(event.parameters){
                          d.no_dokumen = event.parameters.traceNo
                      }
                    }
                }else{
                    // alert('tidak Connect');
                    this.error_termilan = "Terminal POS tidak berjaya disambung";
                }
            }
        },

        bukaKaunter() {
                this.$zcomm
                    .post(
                        this.service_kutipan + "bukakaunter",
                        {}
                    )
                    .then((res) => {
                        if (res.ind_buka != 1) {
                            this.$inertia.visit(
                            this.$route("kutipan.kaunter.buka")
                            );
                        }
                        this.terminal = res.terminal
                        this.terimaan = res.terimaan
                        this.soket()
                    });

        },

        caraBayar() {
                this.$zcomm
                    .post(
                        this.service_utiliti + "lookup/cara_bayar",
                        {}
                    )
                    .then((res) => {
                        
                        this.cara_bayar = res
                       
                    });

        },


        soket(){

            if(this.terminal && this.terminal.ip_address){
                console.log("Starting connection to WebSocket Server")
                this.connection = new WebSocket("wss://"+this.terminal.ip_address+":"+this.terminal.port+"/")
                if ( this.connection.readyState != 1 ) {
                    this.connection.close();
                    this.connection = new WebSocket("wss://"+this.terminal.ip_address+":"+this.terminal.port+"/")
                }
                
                this.connection.onmessage = function(event) {
                  console.log(event);

                    console.log(event.data);
                    console.log(event.data.parameters)
                   for (var i in this.form.cara_bayaran) {
                    if(event.data.parameters){
                        this.form.cara_bayaran[i].no_dokumen  = event.data.parameters.traceNo
                    }
                    if(event.parameters){
                        this.form.cara_bayaran[i].no_dokumen  = event.parameters.traceNo
                    }
                   }
                }

                this.connection.onopen = function(event) {
                  console.log(event)
                  console.log("Successfully connected to the echo websocket server...")
                }
            }
        },

    getData()  {
          var app = this;

          if(this.id){
            if(this.id > 0){
              this.$zcomm.get(this.service_kutipan +'integrasi/'+this.id+''+window.location.search).then(res => {
                this.form_data = res.data;
                this.form.butiran = this.form_data;

                    this.cekAmaunButiran();

              })
              .finally(() => {

                this.loading = false
              });
            }
          }
          
          
        },

   

    cekAmaunButiran() {
            this.amaun_butiran = 0;
            for (var i in this.form_data.butiran_bayaran) {
                this.amaun_butiran =
                    this.amaun_butiran +
                    parseFloat(this.form_data.butiran_bayaran[i].amaun);
            }

            this.form.cara_bayaran[0].amaun = this.amaun_butiran 
        },

    submitResit() {
        // alert(this.id);
            // if (this.$refs.form.validate()) {
            if (this.form.valid == true) {
                this.$zcomm
                    .post(this.service_kutipan +'terimaan_integrasi/'+this.id, this.form, this.form_data)
                    .then((res) => {
                        if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd();
                        }

                        this.$zutil.notify("Rekod telah berjaya dihantar");
                        this.$inertia.visit(
                            this.$route("kutipan.resit.index") +
                                "?resit_id=" +
                                res
                        );
                    })
                    .catch((err) => {})
                    .finally(() => {});
            }
            // }
        },


  
  
   
    
 
  },
  watch: {

  },
  mounted() {

    if(this.id == 0){
      }

    this.getData();
    this.bukaKaunter();
    this.caraBayar();
     this.form.cara_bayaran = [
            {
                lkp_cara_bayaran_id: null,
                lkp_bank_id: null,
                no_dokumen: null,
                amaun: null,
            },
        ];
        this.form = {
            show: true,
            cara_bayaran : [{lkp_cara_bayaran_id: null,lkp_bank_id: null,no_dokumen: null,amaun: null,}],
            // butiran : [{akaun_id : null,keterangan : null,amaun : 0.00 }]
        }

    
      
  },
    
}
</script>